import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AddUser from './components/addUser'
import './assets/styles/base.less'
import { ValidationObserver, ValidationProvider, setInteractionMode, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'camp obligatoriu'
})
extend('email', {
  ...email,
  message: 'email format invalid'
})
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.config.productionTip = false
Vue.component('AddUser', AddUser)

const constraints = {
  'video': true,
  'audio': true
}
// navigator.mediaDevices.getUserMedia(constraints)
//   .then(stream => {
//     console.log('Got MediaStream:', stream);
//   })
//   .catch(error => {
//     console.error('Error accessing media devices.', error);
//   });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
